<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse>
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <label for="kategori">Status</label>
                <a-select
                  v-model="status"
                  placeholder="Ex. Active"
                  @change="searching"
                  class="width-full"
                  allowClear
                >
                  <a-select-option value="Aktif">Active</a-select-option>
                  <a-select-option value="Non Aktif"
                    >Non Active</a-select-option
                  >
                </a-select>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Used For</label>
                  <a-select
                    placeholder="Ex. Customer"
                    v-model="peruntukanSearch"
                    @change="searching"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in peruntukan"
                      :key="item.id"
                      >{{ item.value }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Project"
        createLink="proyekrabCreate"
        :manifestLink="toManifest"
        editLink="proyekrabEdit"
        :dataList="searching"
        :estimasi="false"
        :rab="false"
        :route="route"
        isTransactional
        :disabledCreateEditLink="$route.name=='viewproyekrab.listingAcc'"
      >
        <template #action-card="{ item }">
          <div v-if="item.can_edit" style="width: 100%; display: flex; justify-content: end;">
            <a-button size="small" icon="edit" type="primary" @click="toEdit(item)">Edit</a-button>
          </div>
        </template>
      </DataList>
    </a-col>
    <a-modal v-model="rabVisible" @ok="historyToggle" :footer="null">
      <span slot="title">&nbsp;RAB Information</span>

      <a-row :gutter="8">
        <a-col :span="24">
          <div
            class="m-display-flex flex-row space-between"
            style="padding: 7px"
          >
            <span>Budget:</span>
            <span class="m-list-desc">{{
              formatCurrency(informasi_rab.currency, informasi_rab.total)
            }}</span>
          </div>
          <div
            class="m-display-flex flex-row space-between"
            style="padding: 7px"
          >
            <span>Allocation :</span>
            <span class="m-list-desc">{{
              formatCurrency(informasi_rab.currency, informasi_rab.pemakaian)
            }}</span>
          </div>
          <div
            class="m-display-flex flex-row space-between"
            style="padding: 7px"
          >
            <span>Realization :</span>
            <div class="tright">
              <span class="m-list-desc">{{
                formatCurrency(informasi_rab.currency, informasi_rab.realisasi)
              }}</span>
            </div>
          </div>
          <a-divider class="margin-small" />
          <div
            class="m-display-flex flex-row space-between"
            style="padding: 7px"
          >
            <b>
              <span>Total Realization Budget :</span>
            </b>
            <div class="tright">
              <b>
                <span class="m-list-desc">{{
                  formatCurrency(
                    informasi_rab.currency,
                    informasi_rab.sisa_realisasi
                  )
                }}</span>
              </b>
            </div>
          </div>
          <div
            class="m-display-flex flex-row space-between"
            style="padding: 7px"
          >
            <b>
              <span>Remaining Budget :</span>
            </b>
            <b>
              <span class="m-list-desc">{{
                formatCurrency(informasi_rab.currency, informasi_rab.sisa)
              }}</span>
            </b>
          </div>
          <br />
        </a-col>
      </a-row>
    </a-modal>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
export default {
  name: "List",
  props: ["route"],
  mixins: [CurrencyFormat],
  data() {
    return {
      rabVisible: false,
      loading: true,
      loadingModel: true,
      search: "",
      status: undefined,
      dataList: [],
      peruntukan: [],
      peruntukanSearch: undefined,
      rabValue: "",
      informasi_rab: {
        total: 0,
        pemakaian: 0,
        sisa: 0,
        currency: null,
      },
      enabledEditForAcc: false,
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getNavigation",
      "getScreen",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    subNavigation() {
      let data = [];
      if (
        this.getNavigation !== undefined ||
        this.getNavigation !== null ||
        this.getNavigation.length <= 0
      ) {
        data = _.filter(
          this.getNavigation,
          (nav) =>
            nav.label_menu &&
            nav.label_menu.toLowerCase().indexOf("Keuangan".toLowerCase()) >= 0
        );
      }
      console.log(data);
      return data;
    },
    searching() {
      let output = this.dataList;
      var self = this;
      if (this.search) {
        output = output.filter(
          (obj) =>
            (obj.id ? obj.id : " ").toLowerCase().indexOf(self.search.toLowerCase()) >=
              0 ||
            (obj.tgl_buat? obj.tgl_buat : " ")
              .toLowerCase()
              .indexOf(self.search.toLowerCase()) >= 0 ||
            (obj.perusahaan ? obj.perusahaan : " ")
              .toLowerCase()
              .indexOf(self.search.toLowerCase()) >= 0 ||
            (obj.klien ? obj.klien : " ")
              .toLowerCase()
              .indexOf(self.search.toLowerCase()) >= 0 ||
            (obj.pimpinan_proyek ? obj.pimpinan_proyek : " ")
              .toLowerCase()
              .indexOf(self.search.toLowerCase()) >= 0 ||
            (obj.status ? obj.status : "corrupt")
              .toLowerCase()
              .indexOf(self.search.toLowerCase()) >= 0 ||
            (obj.title ? obj.title : " ")
              .toLowerCase()
              .indexOf(self.search.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        output = output.filter((item) => {
          return item.status === self.status;
        });
      }

      if (this.peruntukanSearch) {
        output = output.filter(
          (obj) =>
            obj.peruntukan
              .toLowerCase()
              .indexOf(self.peruntukanSearch.toLowerCase()) >= 0
        );
      }

      return output;
    },

    toManifest(){
      if(this.$route.name=='proyekrab.listingAcc'){
        return "proyekrab.manifestrabAcc"
      }else if(this.$route.name=='viewproyekrab.listingFin'){
        return "viewproyekrab.manifestrabFin"
      }else{
        return "proyekrab.manifestrab"
      }
    }
  },
  created() {
    this.fetchPeruntukan();
    this.fetchData();
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "project",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          response.data.data.forEach((data) => {
            let statusApp = [];
            try {
              statusApp = JSON.parse(data.status_app || "[]");
            } catch (e) {
              statusApp = [];
            }

            var firstStatus = (statusApp[0] && statusApp[0].status)
            ? statusApp[0].status : null;
            const can_edit = data.status_app === null ? true : firstStatus === "Approved";

            this.dataList.push({
              title: data.kode_proyek,
              title_desc: data.nama_project,
              subdesc: [
                // data.nama_project,
                // data.tgl_start!=null && data.tgl_start.includes("-") && data.tgl_finish!=null && data.tgl_finish.includes("-")
                //   ? this.moment(
                //       data.tgl_start,
                //       this.getStandartFormatDate
                //     ).format(this.getDefaultDateFormat) +
                //     " s/d " +
                //     this.moment(
                //       data.tgl_finish,
                //       this.getStandartFormatDate
                //     ).format(this.getDefaultDateFormat)
                //   : " -",
                [
                  { label: "Budget", value: data.jns_anggaran ? data.jns_anggaran : "-" },
                  { label: "Company", value: data.bendera },
                  { label: "Client", value: data.klien },
                  { label: "Budget Authority", value: data.pimpinan_proyek },
                  { label: "Directorate", value: data.pic_direktorat ? data.pic_direktorat : '-' },
                  { label: "Account Manager", value: data.account_manager },
                  { label: "General Affair", value: data.pic_ga ? data.pic_ga : '-' },
                  { label: "Finance", value: data.pic_finance ? data.pic_finance : '-' },
                ],
              ],
              showDataRight: false,
              // subdesc2: [
              //   [
              //     { label: "Budget Authority", value: data.pimpinan_proyek },
              //     { label: "Account Manager", value: data.account_manager },
              //   ],
              // ],
              timeline: statusApp,
              status: data.status,
              id: data.project_id,
              peruntukan: data.peruntukan,
              can_edit: can_edit
            });
          });

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    fetchPeruntukan() {
      axios({
        method: "get",
        url: this.$serviceUrl + "main/peruntukan",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.peruntukan = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /* showDrawer() {
      this.rabVisible = true;
    },
    hideDrawer() {
      this.rabVisible = false;
    } */
    historyToggle(item) {
      let rabfilter = this.dataList.filter(
        (obj) => obj.id == item.id
      );
      console.log(rabfilter);
      this.informasi_rab = {
        total: rabfilter[0].total ? rabfilter[0].total : 0,
        pemakaian: rabfilter[0].pemakaian ? rabfilter[0].pemakaian :0,
        sisa: rabfilter[0].sisa ? rabfilter[0].sisa :0,
        realisasi: rabfilter[0].realisasi ? rabfilter[0].realisasi : 0,
        sisa_realisasi: rabfilter[0].sisa_realisasi ? rabfilter[0].sisa_realisasi :0,
        currency: rabfilter[0].currency ? rabfilter[0].currency : null
      };
      this.rabVisible = !this.rabVisible;
    },

    toEdit(val){
      this.$router.push({
        name: 'project-update',
        params: { id: val.id, complete: val.can_edit }
      })
    },
  },
  mounted() {
    Event.$on("handleRab", this.historyToggle);
  },
};
</script>

<style>
.tright {
  float: right;
}
</style>